import React, { useState, useEffect } from 'react';
import { Users, UserPlus, 
  Phone, 
  Mail, 
  MapPin, 
  ArrowRight, 
  Star, 
   
  Award, 
  Shield, 
  Scale, 
  FileText, 
  Building,
  ExternalLink,
  ChevronRight,
  Clock,
  CheckCircle,
  Globe,
  Zap,
  Briefcase,
  Gavel,
  Heart,
  Target,
  TrendingUp,
  ShieldCheck,
  BookOpen,
  Lightbulb,
  Eye,
  Calendar,
  UserCheck,
  Building2,
  FileCheck,
  
  Crown,
  Trophy,
  CheckCircle2,
  HelpCircle,
  MessageSquare
} from 'lucide-react';
import WhatsAppIcon from '../components/WhatsAppIcon';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const HomePage = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [visibleSections, setVisibleSections] = useState({
    hero: false,
    about: false,
    services: false,
    testimonials: false,
    contact: false,
    certificates: false,
    team: false
  });

  useEffect(() => {
    setIsVisible(true);
    
    // Intersection Observer for scroll animations
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const sectionId = entry.target.getAttribute('data-section');
          if (sectionId) {
            setVisibleSections(prev => ({
              ...prev,
              [sectionId]: true
            }));
          }
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    // Observe all sections
    const sections = document.querySelectorAll('[data-section]');
    sections.forEach(section => observer.observe(section));

    return () => {
      sections.forEach(section => observer.unobserve(section));
    };
  }, []);

  const whatsappUrl = "https://wa.me/966115115945";

  // Top 3 Services
  const featuredServices = [
    {
      id: 1,
      icon: FileText,
      title: "Contract Drafting & Legal Documents",
      description: "We provide professional contract drafting and legal document services",
      route: "/ContractDrafting",
      color: "from-[#0a3a23] to-[#0a3a23]",
      bgColor: "bg-gradient-to-br from-[#0a3a23]/10 to-[#0a3a23]/5"
    },
    {
      id: 2,
      icon: MessageSquare,
      title: "Legal Consultations",
      description: "Specialized consultations in all legal fields with a team of certified experts",
      route: "/LegalConsultation",
      color: "from-[#0a3a23] to-[#0a3a23]",
      bgColor: "bg-gradient-to-br from-[#0a3a23]/10 to-[#0a3a23]/5"
    },
    {
      id: 3,
      icon: Building,
      title: "Company Formation",
      description: "Comprehensive services for establishing and registering companies of all types",
      route: "/Corporates",
      color: "from-[#0a3a23] to-[#0a3a23]",
      bgColor: "bg-gradient-to-br from-[#0a3a23]/10 to-[#0a3a23]/5"
    }
  ];

  // Featured Client Experiences
  const featuredTestimonials = [
    {
      id: 1,
      platform: "Google Maps",
      content: "I took a consultation from them via WhatsApp, it was useful and helped me, in addition to being free.. excellent service, may God bless you and grant you success, the effort is appreciated, all thanks...",
      rating: 5,
      platformIcon: "🗺️"
    },
    {
      id: 2,
      platform: "TikTok",
      content: "May God bless you, Lord, and elevate you, God willing. Honestly, the peak of sophistication and respect. Lawyer Anas delivers information in a smooth and simple way and supports you morally before anything else. May God increase his likes. I recommend him.",
      rating: 5,
      platformIcon: "🎵"
    },
    {
      id: 3,
      platform: "Google Maps",
      content: "I recommend dealing with lawyer Anas, may God bless him and grant him success. He is a smart, polite, and respectful person. May God increase his likes.",
      rating: 5,
      platformIcon: "🗺️"
    }
  ];

  // Office Statistics
  const stats = [
    {
      icon: UserPlus,
      number: "500+",
      label: "Happy Clients",
      description: "Satisfied clients with our services",
      color: "from-[#0a3a23] to-[#0a3a23]"
    },
    {
      icon: Award,
      number: "15+",
      label: "Years Experience",
      description: "Extensive experience in the legal field",
      color: "from-[#0a3a23] to-[#0a3a23]"
    },
    {
      icon: CheckCircle,
      number: "99%",
      label: "Success Rate",
      description: "High success rate in cases",
      color: "from-[#0a3a23] to-[#0a3a23]"
    },
    {
      icon: Clock,
      number: "24/7",
      label: "Continuous Support",
      description: "Service available around the clock",
      color: "from-[#0a3a23] to-[#0a3a23]"
    }
  ];

  // Office Certificates
  const certificates = [
    {
      icon: Shield,
      title: "Accredited by the Saudi Bar Association",
      description: "The company has obtained a license from the General Department of Advocacy - Ministry of Justice and membership in the Legal Establishment"
    },
    {
      icon: Award,
      title: "Accredited by the Royal Intellectual Property Authority",
      description: "Accredited law firm for registering trademarks, industrial designs, and patents"
    },
    {
      icon: UserPlus,
      title: "Accredited by the Ministry of Human Resources",
      description: "Accredited law firm for reviewing and approving work regulations"
    }
  ];

  // Why Choose Us
  const whyChooseUs = [
    {
      icon: Globe,
      title: "Local Experience According to International Standards",
      description: "We excel with extensive experience in Saudi law while applying international standards"
    },
    {
      icon: Zap,
      title: "Electronic Legal Project Management",
      description: "We use the latest technologies to manage legal projects with high efficiency"
    },
    {
      icon: Clock,
      title: "Automatic Reports on Time",
      description: "We provide periodic and updated reports on the progress of legal projects"
    }
  ];

  // Additional Services
  const additionalServices = [
    {
      icon: FileText,
      title: "E-commerce",
      description: "Drafting policies for websites, electronic platforms, and applications according to Kingdom laws"
    },
    {
      icon: Building,
      title: "Labor Law",
      description: "Preparing work regulations and legal consultations in the field of work and labor"
    },
    {
      icon: Globe,
      title: "International Contracts",
      description: "Drafting and reviewing international contracts and agreements with high professionalism"
    }
  ];



  // الأسئلة الشائعة
  const faqs = [
    {
      question: "How can I book a legal consultation?",
      answer: "You can book a legal consultation by contacting us directly or via WhatsApp, or through the consultation booking page on our website."
    },
    {
      question: "What is the cost of legal services?",
      answer: "The cost varies depending on the type of service and the complexity of the case. We offer a free initial consultation to assess the case and determine the cost."
    },
    {
      question: "Do you provide services throughout the Kingdom?",
      answer: "Yes, we provide our services throughout the Kingdom of Saudi Arabia through our multiple branches."
    },
    {
      question: "What is the duration of case completion?",
      answer: "The duration of completion varies depending on the type and complexity of the case. We strive to complete cases as quickly as possible while ensuring quality."
    }
  ];

  // العملاء والشركاء
  const clients = [
    {
      name: "شركة التقنية المتقدمة",
      logo: "/images/clients/tech-logo.png",
      type: "شركة تقنية",
      color: "from-blue-500 to-purple-600"
    },
    {
      name: "مجموعة العقارات المتحدة",
      logo: "/images/clients/realestate-logo.png",
      type: "شركة عقارية",
      color: "from-[#0a3a23] to-[#0a3a23]"
    },
    {
      name: "بنك التنمية السعودي",
      logo: "/images/clients/bank-logo.png",
      type: "مؤسسة مالية",
      color: "from-yellow-500 to-orange-600"
    },
    {
      name: "شركة النفط الوطنية",
      logo: "/images/clients/oil-logo.png",
      type: "شركة نفط",
      color: "from-red-500 to-pink-600"
    }
  ];

  const governmentLogos = [
    { src: "/images/Home/الدفاع_المدني_السعودي.svg.png", alt: "الدفاع المدني السعودي" },
    { src: "/images/Home/images (3).png", alt: "بلدي" },
    { src: "/images/Home/images (4).png", alt: "أجير" },
    { src: "/images/Home/unnamed.png", alt: "وزارة التجارة" },
    { src: "/images/Home/20231126120602!وزارة_الموارد_البشرية_والتنمية_الاجتماعية.png", alt: "وزارة الموارد البشرية" },
    { src: "/images/Home/images (1).png", alt: "أبشر" },
    { src: "/images/Home/The_Saudi_Ministry_of_Investment_-_logo.png", alt: "وزارة الاستثمار" },
    { src: "/images/Home/images (5).png", alt: "اعتماد" },
    { src: "/images/Home/82326.jpg", alt: "العنوان الوطني" },
    { src: "/images/Home/images (2).png", alt: "فسح" },
  ];

  // Legal Blogs
  const blogs = [
    {
      title: "Digital Evidence | A New Revolution in Legal Proof",
      excerpt: "Previously, proof relied on witnesses and written documents. With technological advancement, transactions now occur electronically.",
      date: "December 2025",
      image: "/images/Home/تصميم بدون عنوان - 2025-08-10T201759.709.png",
      route: "/Blog3",
      readTime: "20 min read"
    },
    {
      title: "The Crime of Blackmail in the Kingdom of Saudi Arabia",
      excerpt: "Blackmail poses a danger to individuals and society, with cases increasing due to modern communication means in Saudi Arabia.",
      date: "July 2025",
      image: "/images/Home/sec2 home.png",
      route: "/Blog2",
      readTime: "4 min read"
    },
    {
      title: "Electronic Fraud in the Kingdom of Saudi Arabia",
      excerpt: "In the digital age, electronic fraud has become a prominent modern crime threatening individuals and institutions.",
      date: "July 2025",
      image: "/images/Home/تصميم بدون عنوان - 2025-08-10T201430.005.png",
      route: "/Blog1",
      readTime: "5 min read"
    }
  ];



  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-[#0a3a23]/10 to-[#0a3a23]/5" dir="ltr">
      
      {/* Header */}
      <Header />
      
      {/* Hero Section */}
      <div 
        data-section="hero"
        className={`relative min-h-screen flex items-center justify-center overflow-hidden transition-all duration-1000 mt-20 ${visibleSections.hero ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
      >
        {/* Background Image */}
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat blur-sm"
          style={{ backgroundImage: "url('/images/Home/تصميم بدون عنوان - 2025-08-16T170838.419.png')" }}
        ></div>
        <div className="absolute inset-0 bg-black opacity-20"></div>
        
        <div className={`relative z-10 w-full px-4 sm:px-6 text-white transition-all duration-1000 delay-300 ${visibleSections.hero ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <div className="flex justify-center sm:justify-start w-full px-4 sm:pl-16 sm:pr-16 pt-20 sm:pt-32">
            <div className="max-w-2xl text-center sm:text-left">
              <div className="mb-6 sm:mb-8">
                <span className="inline-flex items-center gap-2 bg-white/90 backdrop-blur-sm text-[#0a3a23] px-8 sm:px-10 py-5 sm:py-6 rounded-full text-xl sm:text-2xl font-bold shadow-lg">
                  <Award className="w-8 h-8 sm:w-10 sm:h-10" />
                  Anas Abdul Rahman Khayyat Company
                </span>
              </div>
              
              <h1 className="text-base sm:text-xl font-bold mb-4 sm:mb-6 leading-tight font-amiri">
                <span className="inline-flex items-center gap-3 bg-white/90 backdrop-blur-sm text-[#0a3a23] px-5 sm:px-7 py-3 sm:py-4 rounded-full text-base sm:text-xl font-bold shadow-lg">
                  <Award className="w-5 h-5 sm:w-6 sm:h-6" />
                  Most Distinguished Legal Experts
                </span>
              </h1>
              
              <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold mb-6 sm:mb-8 text-white font-amiri drop-shadow-lg">
                in the Kingdom of Saudi Arabia
              </h2>
              
              <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-white leading-relaxed mb-8 sm:mb-12 px-4 sm:px-0 font-medium drop-shadow-lg">
                We are committed to providing comprehensive, well-studied legal services based on solid religious and systematic foundations
              </p>
              
              <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center sm:justify-start mb-12 sm:mb-16 px-4 sm:px-0">
                <a
                  href={`${whatsappUrl}?text=I want a legal consultation`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group inline-flex items-center justify-center gap-2 sm:gap-3 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] text-white px-4 sm:px-6 py-3 sm:py-3 rounded-xl font-bold text-sm sm:text-base hover:from-[#0a3a23]/90 hover:to-[#0a3a23]/90 transition-all duration-300 shadow-xl hover:shadow-2xl transform hover:scale-105"
                >
                  <WhatsAppIcon className="w-4 h-4 sm:w-5 sm:h-5 group-hover:animate-pulse" />
                  <span className="whitespace-nowrap">Request Immediate Consultation</span>
                </a>
                
                <Link
                  to="/Services"
                  className="group inline-flex items-center justify-center gap-2 sm:gap-3 bg-white/90 backdrop-blur-sm text-[#0a3a23] px-4 sm:px-6 py-3 sm:py-3 rounded-xl font-bold text-sm sm:text-base hover:bg-white transition-all duration-300 border-2 border-white shadow-xl hover:shadow-2xl transform hover:scale-105"
                >
                  <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform" />
                  <span className="whitespace-nowrap">Explore Our Services</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* About Section */}
      <div 
        data-section="about"
        className="py-12 sm:py-20 bg-white"
      >
        

        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="grid lg:grid-cols-2 gap-8 sm:gap-16 items-start">
            <div className={`transition-all duration-1000 lg:order-1 ${visibleSections.about ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
              <div className="mb-6 sm:mb-8 text-left">
                <span className="inline-flex items-center gap-2 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] text-white px-3 sm:px-4 py-2 rounded-full text-xs sm:text-sm font-medium">
                  <BookOpen className="w-3 h-3 sm:w-4 sm:h-4" />
                  Company Overview
                </span>
              </div>
              
              <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 sm:mb-8 font-amiri text-left !text-left" style={{textAlign: 'left', direction: 'ltr'}}>
                Anas Abdul Rahman Khayyat Company for Advocacy and Legal Consultations
              </h2>
              
              <div className="mb-6 sm:mb-8 text-left">
                <span className="inline-flex items-center gap-2 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] text-white px-4 sm:px-6 py-2 sm:py-3 rounded-full text-sm sm:text-base font-medium shadow-lg">
                  <MapPin className="w-4 h-4 sm:w-5 sm:h-5" />
                  Jeddah City
                </span>
              </div>
              
              <div className="space-y-6 sm:space-y-8 text-sm sm:text-lg text-gray-700 leading-relaxed text-left">
                <div className="bg-gradient-to-br from-[#0a3a23]/10 to-[#0a3a23]/5 rounded-xl p-6 border border-[#0a3a23]/20 shadow-sm">
                  <p className="text-gray-800 font-medium text-base sm:text-lg text-left">
                    Anas Law Firm and Legal Consultations Company is one of the leading companies in the field of advocacy and legal consultations in the Kingdom of Saudi Arabia. It is a professional company licensed and accredited by government agencies and has taken Jeddah as its main headquarters to manage its business and provide services to all clients inside and outside the Kingdom of Saudi Arabia.
                  </p>
                </div>
                
                <div className="space-y-4">
                  <h3 className="text-xl sm:text-2xl font-bold text-gray-900 flex items-center gap-2 font-amiri text-left">
                    <div className="w-2 h-2 bg-[#0a3a23] rounded-full"></div>
                    Our Distinguished Services:
                  </h3>
                  <p className="text-gray-700 text-base sm:text-lg text-left">
                    Anas Law Firm and Legal Consultations Company provides a number of legal services to its clients from individuals, companies, factories, banks, and government agencies. The company excels in drafting, amending contracts and agreements, establishing companies and entities, managing merger and acquisition operations and listing in financial markets, and issuing government licenses for all commercial, industrial, and service activities.
                  </p>
                </div>
                
                <div className="space-y-4">
                  <h3 className="text-xl sm:text-2xl font-bold text-gray-900 flex items-center gap-2 font-amiri text-left">
                    <div className="w-2 h-2 bg-[#0a3a23] rounded-full"></div>
                    Our Extensive Experience:
                  </h3>
                  <p className="text-gray-700 text-base sm:text-lg text-left">
                    The company enjoys qualified competencies in providing legal services, with cumulative experience exceeding 12 years in litigation, arbitration, providing legal consultations, drafting contracts and agreements, leading negotiation operations and financial and in-kind settlements, liquidating companies and estates, collecting debts and receivables, innovating investment solutions and financial and administrative organization strategies and restructuring, and organizing policies and charters for family companies, endowment entities, and profit and non-profit organizations.
                  </p>
                </div>
                
                <div className="bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] p-6 sm:p-8 rounded-2xl sm:rounded-3xl text-white shadow-lg">
                  <div className="flex items-start gap-4 sm:gap-6">
                    <div className="w-12 h-12 sm:w-16 sm:h-16 bg-white/20 rounded-2xl flex items-center justify-center flex-shrink-0">
                      <Lightbulb className="w-6 h-6 sm:w-8 sm:h-8 text-yellow-300" />
                    </div>
                    <div className="text-left">
                      <h4 className="text-xl sm:text-2xl font-bold mb-3 text-white font-amiri text-left">Our Goal</h4>
                      <p className="text-white/90 text-base sm:text-lg leading-relaxed text-left">
                        Building long-term relationships with our clients and providing the best solutions for their legal and institutional needs, with a focus on innovation and excellence in providing integrated legal services
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="mt-6 sm:mt-8 text-left">
                <Link
                  to="/About"
                  className="inline-flex items-center gap-2 sm:gap-3 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] text-white px-6 sm:px-8 py-3 sm:py-4 rounded-xl sm:rounded-2xl font-bold hover:from-[#0a3a23]/90 hover:to-[#0a3a23]/90 transition-all duration-300 shadow-lg hover:shadow-xl text-sm sm:text-base"
                >
                  <span>Read More</span>
                  <ChevronRight className="w-4 h-4 sm:w-5 sm:h-5" />
                </Link>
              </div>
            </div>
            
            <div className={`relative transition-all duration-1000 delay-300 lg:order-1 ${visibleSections.about ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
              <div className="relative lg:sticky lg:top-16 lg:mt-120 mt-20 lg:mt-40">
                {/* الصورة الأولى - كبيرة */}
                <div className="relative">
                                              <img
                              src="/images/صور الموقع (1)/1.jpg"
                              alt="شركة أنس للمحاماة - صورة 1"
                              className="rounded-2xl sm:rounded-3xl shadow-xl sm:shadow-2xl w-full h-96 sm:h-[28rem] object-cover"
                            />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-2xl sm:rounded-3xl"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* شهادات الشركة */}
      <div 
        data-section="certificates"
        className="py-20 bg-white"
      >
        <div className="max-w-6xl mx-auto px-6">
          <div className={`text-center mb-16 transition-all duration-1000 ${visibleSections.certificates ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <div className="flex items-center justify-center gap-6 mb-6">
              <div className="relative group">
                <div className="w-16 h-16 bg-gradient-to-br from-[#0a3a23]/20 to-[#0a3a23]/10 rounded-2xl flex items-center justify-center shadow-sm group-hover:shadow-md transition-all duration-300 group-hover:scale-105 border border-[#0a3a23]/30">
                  <Award className="w-8 h-8 text-[#0a3a23] animate-pulse" />
                </div>
                <div className="absolute -top-1 -right-1 w-4 h-4 bg-[#0a3a23]/40 rounded-full animate-pulse opacity-60"></div>
                <div className="absolute -bottom-1 -left-1 w-3 h-3 bg-[#0a3a23]/30 rounded-full animate-pulse opacity-60"></div>
              </div>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 font-amiri">
              Company Certificates
            </h2>
            </div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              We are proud to have obtained official accreditations from the most important bodies and ministries
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {certificates.map((cert, index) => (
              <div 
                key={index} 
                className="bg-gradient-to-br from-[#0a3a23]/10 to-[#0a3a23]/5 rounded-3xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 text-center group"
              >
                <div className="w-20 h-20 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] rounded-3xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                  <cert.icon className="w-10 h-10 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4 font-amiri">{cert.title}</h3>
                <p className="text-gray-600 leading-relaxed">{cert.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>



      {/* فريق العمل */}
      <div 
        data-section="team"
        className="py-12 sm:py-20 bg-gradient-to-br from-[#0a3a23]/5 to-white"
      >
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className={`text-center mb-12 sm:mb-16 transition-all duration-1000 ${visibleSections.team ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
                          <div className="inline-flex items-center gap-2 sm:gap-3 bg-gradient-to-r from-[#0a3a23]/20 to-[#0a3a23]/10 text-[#0a3a23] px-4 sm:px-6 py-2 sm:py-3 rounded-full text-xs sm:text-sm font-medium mb-4 sm:mb-6">
                <Users className="w-4 h-4 sm:w-5 sm:h-5" />
                Our Team
              </div>
            

            <p className="text-sm sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto px-4 sm:px-0">
              We are proud of our team consisting of elite lawyers and legal consultants, with high academic qualifications and diverse professional experiences.
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 items-center">
            {/* النص */}
            <div className={`transition-all duration-1000 ${visibleSections.team ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
              <div className="space-y-6 sm:space-y-8">
                <div className="bg-gradient-to-br from-[#0a3a23]/10 to-[#0a3a23]/5 rounded-xl p-6 sm:p-8 border border-[#0a3a23]/20">
                  <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-6 font-amiri flex items-center gap-3">
                    <Users className="w-6 h-6 sm:w-8 sm:h-8 text-[#0a3a23]" />
                    Legal Experts
                  </h3>
                  <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 text-left">
                    Our team includes elite lawyers and legal consultants who are academically qualified and professionally experienced in various legal specializations.
                  </p>
                  <ul className="space-y-2 sm:space-y-3">
                    <li className="flex items-center gap-2 text-sm sm:text-base text-gray-700">
                      <CheckCircle className="w-4 h-4 sm:w-5 sm:h-5 text-[#0a3a23]" />
                      Cumulative experience exceeding 12 years
                    </li>
                    <li className="flex items-center gap-2 text-sm sm:text-base text-gray-700">
                      <CheckCircle className="w-4 h-4 sm:w-5 sm:h-5 text-[#0a3a23]" />
                      High academic qualifications
                    </li>
                    <li className="flex items-center gap-2 text-sm sm:text-base text-gray-700">
                      <CheckCircle className="w-4 h-4 sm:w-5 sm:h-5 text-[#0a3a23]" />
                      Diverse legal specializations
                    </li>
                    <li className="flex items-center gap-2 text-sm sm:text-base text-gray-700">
                      <CheckCircle className="w-4 h-4 sm:w-5 sm:h-5 text-[#0a3a23]" />
                      Commitment to highest quality standards
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* الصورة */}
            <div className={`relative transition-all duration-1000 delay-300 ${visibleSections.team ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
              <div className="relative">
                <img 
                  src="/images/صور الموقع (1)/41.jpg" 
                  alt="فريق العمل - شركة أنس للمحاماة" 
                  className="w-full h-80 sm:h-96 object-cover rounded-2xl sm:rounded-3xl shadow-2xl"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a3a23]/30 to-transparent rounded-2xl sm:rounded-3xl"></div>
                
                {/* عناصر عائمة */}
                <div className="absolute -top-4 -right-4 w-8 h-8 sm:w-12 sm:h-12 bg-gradient-to-br from-[#0a3a23] to-[#0a3a23] rounded-full animate-pulse shadow-lg"></div>
                <div className="absolute -bottom-4 -left-4 w-6 h-6 sm:w-10 sm:h-10 bg-gradient-to-br from-[#0a3a23]/80 to-[#0a3a23]/60 rounded-full animate-bounce shadow-lg" style={{animationDuration: '3s'}}></div>
                
                {/* Text on Image */}
                <div className="absolute bottom-6 left-6 right-6 text-white">
                  <h4 className="text-lg sm:text-xl font-bold mb-2">Distinguished Legal Team</h4>
                  <p className="text-sm sm:text-base opacity-90">Elite of Lawyers and Consultants</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Featured Services */}
      <div 
        data-section="services"
        className="py-12 sm:py-20 bg-white"
      >
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className={`text-center mb-12 sm:mb-16 transition-all duration-1000 ${visibleSections.services ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 font-amiri">
              Distinguished Services
            </h2>
            <p className="text-sm sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto px-4 sm:px-0">
              We provide a comprehensive set of specialized legal services to meet all your needs
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-8 sm:mb-12">
            {featuredServices.map((service, index) => (
              <div 
                key={service.id} 
                className={`group bg-gradient-to-br from-[#0a3a23]/10 to-[#0a3a23]/5 rounded-xl sm:rounded-2xl p-6 sm:p-8 shadow-sm hover:shadow-lg transition-all duration-500 border border-[#0a3a23]/20 hover:border-[#0a3a23]/30 ${visibleSections.services ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                style={{ transitionDelay: `${index * 200}ms` }}
              >
                <div className="text-center mb-4 sm:mb-6">
                  <div className="w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-br from-[#0a3a23]/20 to-[#0a3a23]/10 rounded-xl sm:rounded-2xl flex items-center justify-center mx-auto mb-3 sm:mb-4 group-hover:scale-110 transition-transform duration-300">
                    <service.icon className="w-6 h-6 sm:w-8 sm:h-8 text-[#0a3a23]" />
                  </div>
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3 font-amiri">{service.title}</h3>
                </div>
                
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-4 sm:mb-6 text-center">
                    {service.description}
                  </p>
                  
                <div className="text-center">
                  <Link
                    to={service.route}
                    className="inline-flex items-center gap-1 sm:gap-2 text-[#0a3a23] hover:text-[#0a3a23]/80 font-semibold transition-colors group text-sm sm:text-base"
                  >
                    <span>Read More</span>
                    <ArrowRight className="w-3 h-3 sm:w-4 sm:h-4 group-hover:translate-x-1 transition-transform" />
                  </Link>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center">
            <Link
              to="/Services"
              className="inline-flex items-center gap-2 sm:gap-3 bg-[#0a3a23] text-white px-6 sm:px-8 py-3 sm:py-4 rounded-xl font-semibold text-sm sm:text-lg hover:bg-[#0a3a23]/90 transition-all duration-300 shadow-sm"
            >
              <span>View All Services</span>
              <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5" />
            </Link>
          </div>
        </div>
      </div>

      





      {/* خدمات الدوائر الحكومية */}
      <div className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 font-amiri">
              Government Department Services
            </h2>
          </div>

          <div className="flex flex-wrap justify-center items-center gap-8">
            {governmentLogos.map((logo, index) => (
              <div 
                key={index} 
                className="group p-4 rounded-full bg-white shadow-lg hover:shadow-xl transition-all duration-300"
              >
                <img 
                  src={logo.src} 
                  alt={logo.alt}
                  className="w-24 h-24 object-contain rounded-full group-hover:scale-110 transition-transform duration-300"
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Legal Blogs */}
      <div className="py-20 bg-gradient-to-br from-[#0a3a23]/10 to-[#0a3a23]/5" dir="ltr">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 font-amiri">
              Legal Blogs
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Useful articles and important information
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {blogs.map((blog, index) => (
              <div 
                key={index} 
                className="bg-white rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 overflow-hidden group"
              >
                <div className="relative">
                  <img 
                    src={blog.image} 
                    alt={blog.title}
                    className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute top-4 right-4 bg-[#0a3a23] text-white px-3 py-1 rounded-full text-sm">
                    {blog.date}
                  </div>
                </div>
                <div className="p-6 text-left">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-[#0a3a23] transition-colors font-amiri text-left">
                    {blog.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed mb-4 text-left">
                    {blog.excerpt}
                  </p>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2 text-sm text-gray-500">
                      <Clock className="w-4 h-4" />
                      <span>{blog.readTime}</span>
                    </div>
                    <Link
                      to={blog.route}
                      className="inline-flex items-center gap-2 text-[#0a3a23] hover:text-[#0a3a23]/80 font-semibold transition-colors"
                    >
                      <span>Read More</span>
                      <ArrowRight className="w-4 h-4" />
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
                          <Link
                to="/Blog"
                className="inline-flex items-center gap-3 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] text-white px-8 py-4 rounded-2xl font-bold text-lg hover:from-[#0a3a23]/90 hover:to-[#0a3a23]/90 transition-all duration-300"
              >
                <span>View All Blogs</span>
                <ArrowRight className="w-6 h-6" />
              </Link>
          </div>
        </div>
      </div>

      {/* Frequently Asked Questions */}
      <div className="py-20 bg-gradient-to-br from-[#0a3a23]/10 to-[#0a3a23]/5" dir="ltr">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-3 bg-white text-[#0a3a23] px-6 py-3 rounded-full text-sm font-medium mb-6 shadow-sm">
              <HelpCircle className="w-5 h-5" />
              Frequently Asked Questions
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 font-amiri">
              Frequently Asked Questions
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Answers to the most common questions
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {faqs.map((faq, index) => (
              <div 
                key={index} 
                className="bg-white p-8 rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 border border-[#0a3a23]/20 hover:border-[#0a3a23]/30 group"
              >
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-[#0a3a23] to-[#0a3a23] rounded-2xl flex items-center justify-center flex-shrink-0 mt-1 group-hover:scale-110 transition-transform duration-300 shadow-md">
                    <HelpCircle className="w-6 h-6 text-white" />
                  </div>
                  <div className="flex-1 text-left">
                    <h3 className="text-xl font-bold text-gray-900 mb-4 group-hover:text-[#0a3a23] transition-colors font-amiri text-left">
                      {faq.question}
                    </h3>
                    <p className="text-gray-600 leading-relaxed text-lg text-left">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <div className="bg-white rounded-2xl p-8 shadow-lg border border-[#0a3a23]/20 max-w-2xl mx-auto">
              <div className="flex items-center justify-center gap-3 mb-4">
                <div className="w-10 h-10 bg-gradient-to-br from-[#0a3a23] to-[#0a3a23] rounded-xl flex items-center justify-center">
                  <WhatsAppIcon className="w-5 h-5 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 font-amiri text-left">Do you have another question?</h3>
              </div>
              <p className="text-gray-600 mb-6 text-left">
                Don't hesitate to contact us for a comprehensive answer
              </p>
              <div className="flex flex-col sm:flex-row gap-3 justify-center">
                <Link
                  to="/FAQ"
                  className="inline-flex items-center gap-2 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] text-white px-6 py-3 rounded-xl font-semibold text-sm hover:from-[#0a3a23]/90 hover:to-[#0a3a23]/90 transition-all duration-300"
                >
                  <span>View All Questions</span>
                  <ArrowRight className="w-4 h-4" />
                </Link>
                <Link
                  to="/Contact"
                  className="inline-flex items-center gap-2 bg-white text-[#0a3a23] px-6 py-3 rounded-xl font-semibold text-sm hover:bg-[#0a3a23]/10 transition-all duration-300 border border-[#0a3a23]"
                >
                  <WhatsAppIcon className="w-4 h-4" />
                  <span>Contact Us</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Featured Testimonials */}
      <div 
        data-section="testimonials"
        className="py-12 sm:py-20 bg-white"
      >
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className={`text-center mb-12 sm:mb-16 transition-all duration-1000 ${visibleSections.testimonials ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
                          <div className="inline-flex items-center gap-2 sm:gap-3 bg-gradient-to-r from-[#0a3a23]/20 to-[#0a3a23]/10 text-[#0a3a23] px-4 sm:px-6 py-2 sm:py-3 rounded-full text-xs sm:text-sm font-medium mb-4 sm:mb-6">
                <Star className="w-4 h-4 sm:w-5 sm:h-5" />
                Our Clients' Experiences
              </div>
              
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 font-amiri">
              Our Clients' Opinions
            </h2>
            <p className="text-sm sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto px-4 sm:px-0">
              We are proud of our clients' trust and satisfaction with our services
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {featuredTestimonials.map((testimonial, index) => (
              <div 
                key={testimonial.id} 
                className={`bg-gradient-to-br from-[#0a3a23]/10 to-[#0a3a23]/5 rounded-xl sm:rounded-3xl p-6 sm:p-8 shadow-lg hover:shadow-xl transition-all duration-500 border border-[#0a3a23]/20 hover:border-[#0a3a23]/30 group ${visibleSections.testimonials ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                style={{ transitionDelay: `${index * 200}ms` }}
              >
                <div className="flex items-center mb-4 sm:mb-6">
                  <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-gradient-to-br from-[#0a3a23] to-[#0a3a23] flex items-center justify-center shadow-lg group-hover:scale-105 transition-transform duration-300">
                    <span className="text-lg sm:text-xl">{testimonial.platformIcon}</span>
                  </div>
                  <div className="mr-3 sm:mr-4">
                    <h4 className="font-bold text-gray-900 text-sm sm:text-lg group-hover:text-[#0a3a23] transition-colors">{testimonial.platform}</h4>
                  </div>
                </div>
                
                <div className="flex items-center mb-3 sm:mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 sm:w-5 sm:h-5 text-yellow-400 fill-current" />
                  ))}
                </div>
                
                <p className="text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed italic">
                  "{testimonial.content}"
                </p>
              </div>
            ))}
          </div>

          <div className="text-center mt-8 sm:mt-12">
            <Link
              to="/Testimonials"
              className="inline-flex items-center gap-2 sm:gap-3 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] text-white px-6 sm:px-8 py-3 sm:py-4 rounded-xl sm:rounded-2xl font-bold text-sm sm:text-lg hover:from-[#0a3a23]/90 hover:to-[#0a3a23]/90 transition-all duration-300 shadow-lg"
            >
              <span>View All Experiences</span>
              <ArrowRight className="w-4 h-4 sm:w-6 sm:h-6" />
            </Link>
          </div>
        </div>
      </div>

      {/* Contact Section */}
      <div 
        data-section="contact"
        className="py-12 sm:py-20 bg-gradient-to-br from-[#0a3a23]/5 to-white"
      >
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className={`text-center mb-12 sm:mb-16 transition-all duration-1000 ${visibleSections.contact ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <div className="inline-flex items-center gap-2 sm:gap-3 bg-gradient-to-r from-[#0a3a23]/20 to-[#0a3a23]/10 text-[#0a3a23] px-4 sm:px-6 py-2 sm:py-3 rounded-full text-xs sm:text-sm font-medium mb-4 sm:mb-6">
              <WhatsAppIcon className="w-4 h-4 sm:w-5 sm:h-5" />
              Contact Information
            </div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 font-amiri">
              Contact Us
            </h2>
            <p className="text-sm sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto px-4 sm:px-0">
              We are here to help you with all your legal needs
            </p>
          </div>

          {/* Main Contact Information */}
          <div className="bg-white rounded-3xl shadow-2xl p-8 sm:p-12 mb-8 sm:mb-12 border border-[#0a3a23]/10">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
              {/* Unified Number */}
              <div className={`group text-center p-6 sm:p-8 bg-gradient-to-br from-[#0a3a23]/10 to-[#0a3a23]/5 rounded-2xl hover:from-[#0a3a23]/20 hover:to-[#0a3a23]/10 transition-all duration-500 hover:shadow-lg hover:scale-105 ${visibleSections.contact ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} style={{ transitionDelay: '0ms' }}>
                <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br from-[#0a3a23] to-[#0a3a23] rounded-2xl flex items-center justify-center mx-auto mb-4 sm:mb-6 shadow-lg group-hover:scale-110 transition-transform duration-300">
                  <Phone className="w-8 h-8 sm:w-10 sm:h-10 text-white" />
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3 font-amiri text-center">Unified Number</h3>
                <a href="tel:920033053" className="text-lg sm:text-xl font-bold text-[#0a3a23] hover:text-[#0a3a23]/80 transition-colors">
                  920033053
                </a>
              </div>

              {/* Address */}
              <div className={`group text-center p-6 sm:p-8 bg-gradient-to-br from-[#0a3a23]/10 to-[#0a3a23]/5 rounded-2xl hover:from-[#0a3a23]/20 hover:to-[#0a3a23]/10 transition-all duration-500 hover:shadow-lg hover:scale-105 ${visibleSections.contact ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} style={{ transitionDelay: '200ms' }}>
                <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br from-[#0a3a23] to-[#0a3a23] rounded-2xl flex items-center justify-center mx-auto mb-4 sm:mb-6 shadow-lg group-hover:scale-110 transition-transform duration-300">
                  <MapPin className="w-8 h-8 sm:w-10 sm:h-10 text-white" />
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3 font-amiri text-center">Address</h3>
                <p className="text-sm sm:text-base text-gray-700 font-medium text-center">
                  Kingdom of Saudi Arabia - Jeddah City - Al Marjan District - Al Nayfah Center - First Floor - Office No. 8
                </p>
                
              </div>

              {/* Email */}
              <div className={`group text-center p-6 sm:p-8 bg-gradient-to-br from-[#0a3a23]/10 to-[#0a3a23]/5 rounded-2xl hover:from-[#0a3a23]/20 hover:to-[#0a3a23]/10 transition-all duration-500 hover:shadow-lg hover:scale-105 ${visibleSections.contact ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} style={{ transitionDelay: '400ms' }}>
                <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br from-[#0a3a23] to-[#0a3a23] rounded-2xl flex items-center justify-center mx-auto mb-4 sm:mb-6 shadow-lg group-hover:scale-110 transition-transform duration-300">
                  <Mail className="w-8 h-8 sm:w-10 sm:h-10 text-white" />
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3 font-amiri text-center">Email</h3>
                <a href="mailto:info@khayat.sa" className="text-sm sm:text-base font-bold text-[#0a3a23] hover:text-[#0a3a23]/80 transition-colors break-all">
                  info@khayat.sa
                </a>
              </div>


            </div>
          </div>


        </div>
      </div>

      {/* Floating Contact Button */}
      <a
        href="tel:920033053"
        className="fixed bottom-20 sm:bottom-28 left-4 sm:left-6 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] text-white p-3 sm:p-4 rounded-full shadow-2xl hover:shadow-[#0a3a23]/25 transition-all duration-300 z-50 hover:scale-110"
      >
        <Phone className="w-5 h-5 sm:w-6 sm:h-6" />
      </a>

      {/* Floating WhatsApp Button */}
      <a
        href={`${whatsappUrl}?text=I want a legal consultation`}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-4 sm:bottom-6 left-4 sm:left-6 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] text-white p-3 sm:p-4 rounded-full shadow-2xl hover:shadow-[#0a3a23]/25 transition-all duration-300 z-50 hover:scale-110"
      >
        <WhatsAppIcon className="w-5 h-5 sm:w-6 sm:h-6" />
      </a>

      {/* Custom CSS for animations */}
      <style jsx>{`
        @keyframes blob {
          0% {
            transform: translate(0px, 0px) scale(1);
          }
          33% {
            transform: translate(30px, -50px) scale(1.1);
          }
          66% {
            transform: translate(-20px, 20px) scale(0.9);
          }
          100% {
            transform: translate(0px, 0px) scale(1);
          }
        }
        @keyframes spin-slow {
          from {
            transform: translate(-50%, -50%) rotate(0deg);
          }
          to {
            transform: translate(-50%, -50%) rotate(360deg);
          }
        }
        .animate-blob {
          animation: blob 7s infinite;
        }
        .animate-spin-slow {
          animation: spin-slow 8s linear infinite;
        }
        .animation-delay-2000 {
          animation-delay: 2s;
        }
        .animation-delay-4000 {
          animation-delay: 4s;
        }
        .animation-delay-1000 {
          animation-delay: 1s;
        }
      `}</style>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default HomePage; 
